import { Children, PureComponent } from 'react';

import { ExpandableBox } from '@optimus-web/helpers';
import { ExpandableList } from '../ExpandableList';
import { ExpandIcon } from '../ExpandIcon';
import { ListItem as ListItemElement } from '../ListItem';
import toFlatChildrenArray from '../utils/toFlatChildrenArray';
import { ExpandableListItemFactory, ExpandableListItemProps } from './types';

/**
 * @deprecated use Accordion
 */
export const expandableListItemFactory = ({ ListItem = ListItemElement }: ExpandableListItemFactory = {}) =>
    class ExpandablelListItem extends PureComponent<React.PropsWithChildren<ExpandableListItemProps>> {
        static defaultProps = { depth: 0, opened: false, multiSelect: false };

        render() {
            const { children, depth, opened, multiSelect, ...other } = this.props;

            const flatChildren = toFlatChildrenArray(children);
            if (Children.count(flatChildren) === 0) {
                return null;
            }

            return (
                <>
                    <ListItem {...other} rightIcon={<ExpandIcon expanded={opened} />} depth={depth} />
                    <ExpandableBox expanded={opened}>
                        <ExpandableList depth={depth + 1} multiSelect={multiSelect}>
                            {children}
                        </ExpandableList>
                    </ExpandableBox>
                </>
            );
        }
    };

export const ExpandableListItem = expandableListItemFactory();
